import { render } from "./ComposePage.vue?vue&type=template&id=047d8f7a&ts=true"
import script from "./ComposePage.vue?vue&type=script&lang=ts"
export * from "./ComposePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__